import React from 'react';
import {Box, Button} from '@mui/material';

import './empty.scss'
import {useNavigate} from "react-router-dom";

const Empty = ({title, subtitle, btn = true}: any) => {
    const navigate = useNavigate()

    return <Box className={'empty-study-wrapper'}>
        <Box className={'empty-study-title'}>{title}</Box>
        <Box className={'empty-study-subtitle'}>{subtitle}</Box>
        {btn ? <Button className={'empty-study-btn'}
                       onClick={()=>navigate('/')}
                       variant="contained">На главную</Button> : null}

    </Box>
}

export default Empty